module.exports = __webpack_public_path__ + "img/sms_message.dee4e790.svg";